import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    private readonly onDestroy = new Subject<void>();

    constructor(private router: Router, private titleService: Title) {
        const navEndEvent$ = router.events.pipe(
            filter(e => e instanceof NavigationEnd)
            );
            navEndEvent$.subscribe((e: any) => {                

                this.titleService.setTitle(environment.pageTitlePrepend + 'Admin Flywheel Digital - Retail Insights')
            })

    }

    ngOnInit(): void {
        this.router.events
            .pipe(takeUntil(this.onDestroy))
            .subscribe((evt) => {
                if (!(evt instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
    }
}
